export class RNG {
  constructor(seed = Date.now()) {
    this._seed = seed >>> 0;
  }
  random() {
    // xorshift32
    let x = this._seed;
    x ^= x << 13;
    x ^= x >>> 17;
    x ^= x << 5;
    this._seed = x >>> 0;
    return (this._seed & 0xffffffff) / 0x100000000;
  }
}


